import React, { useState } from 'react'
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { MdPauseCircleOutline } from 'react-icons/md';
import { RiSurveyLine } from 'react-icons/ri';
import { useLocation, useNavigate, useParams } from 'react-router-dom';


const Sidebar = ({ children }) => {
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();
    const [collapse, setCollapse] = useState(false);
    const SideBarData = [
        {
            name: "Research Design",
            path: `/qualitative-surveys/${id}/research-design`,
            subPath: "research-design",
            icon: <RiSurveyLine size={23} />,
        },
        {
            name: "Participant Management",
            path: `/qualitative-surveys/${id}/participant-management`,
            subPath: "participant-management",
            icon: <MdPauseCircleOutline size={23} />,
        }
    ];

    return (
        <div className="w-full flex" style={{ height: "calc(100vh - 64px)" }}>
            <div
                className={`
           ${collapse ? "w-[70px]" : "w-[280px]"}
           transition-all duration-300 ease-in-out bg-white z-[20] border-r border-gray-200 shadow-sm relative flex flex-col`}
            >

                {/* Collapse/Expand Button */}
                <button
                    className={`absolute top-10 right-[-16px] w-8 h-8 flex items-center justify-center rounded-full transition-all duration-300 cursor-pointer bg-[#0226BE] hover:bg-[#021ea8] shadow-md z-10 ${collapse ? "" : ""
                        }`}
                    onClick={(e) => setCollapse(!collapse)}
                    title={collapse ? "Expand sidebar" : "Collapse sidebar"}
                >
                    {collapse ? (
                        <IoIosArrowForward color="white" size={18} />
                    ) : (
                        <IoIosArrowBack color="white" size={18} />
                    )}
                </button>

                {/* Navigation Items */}
                <div className="flex-1 overflow-y-auto containerScroll py-4 px-3">
                    <nav className="flex flex-col gap-1">
                        {SideBarData?.map((data, ind) => {
                            const isActive = location.pathname?.includes(data?.subPath);
                            return (
                                <button
                                    key={ind}
                                    onClick={(e) => navigate(data?.path)}
                                    className={`
                       group relative flex items-center transition-all duration-200 rounded-lg
                       ${collapse ? "justify-center px-2 py-3" : "px-4 py-3 gap-3"}
                       ${isActive
                                            ? "bg-blue-50 text-[#0226BE] font-[600]"
                                            : "text-gray-600 hover:bg-gray-50 hover:text-[#0226BE] font-[500]"
                                        }
                     `}
                                    title={collapse ? data?.name : ""}
                                >
                                    {/* Active indicator */}
                                    {isActive && !collapse && (
                                        <div className="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-8 bg-[#0226BE] rounded-r-full"></div>
                                    )}

                                    {/* Icon */}
                                    <div
                                        className={`
                         flex-shrink-0 transition-colors
                         ${isActive ? "text-[#0226BE]" : "text-gray-500 group-hover:text-[#0226BE]"}
                       `}
                                    >
                                        {React.cloneElement(data?.icon, {
                                            size: collapse ? 22 : 20,
                                        })}
                                    </div>

                                    {/* Text */}
                                    {!collapse && (
                                        <span
                                            className={`
                           text-[14px] whitespace-nowrap transition-all duration-300
                           ${isActive ? "font-[600]" : "font-[500]"}
                         `}
                                        >
                                            {data?.name}
                                        </span>
                                    )}
                                </button>
                            );
                        })}
                    </nav>
                </div>
            </div>
            <div
                className="transition-all duration-300 ease-in-out flex items-start justify-center overflow-y-auto containerScroll bg-gray-50"
                style={{
                    width: collapse ? "calc(100% - 70px)" : "calc(100% - 280px)",
                    height: "calc(100vh - 64px)",
                }}
            >
                <div className="w-full max-w-[1600px] px-6 py-8">{children}</div>
            </div>
        </div>
    );
}

export default Sidebar